<template>
  <!-- 六大优势模块 -->   
  <div class="advantage container">
    <el-row class="count-list advantage-count">
      <el-col class="advantage-item" :xs="12" :sm="8" :md="8" :lg="4" :xl="4" v-for="(item, index) in advantageList" :key="index">
        <div 
          class="advant-box flex-align-center flex-center"
          @mouseenter="advantageEnter(index, false)"
          @mouseleave="advantageLeave(index, true)">
          <div class="advant-default" v-if="item.advantIcon">
            <div class="img-box">
              <img :src="item.image" alt="">
            </div>
            <h3 class="item-title">{{ item.advant }}</h3>
          </div>
          <div v-html="item.desc" v-show="advantHover" class="advant-hover fade-enter-active" v-else>
            <!-- {{item.desc}} -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      advantIcon: true,
      advantHover: true,
      advantageList: [
        {
          image: require('../../assets/image/advantage/advantage1.png'),
          advant: '全天候服务',
          desc: '经验丰富TD团队<br/>全天候服务',
          advantIcon: true
        },
        {
          image: require('../../assets/image/advantage/advantage2.png'),
          advant: '专线覆盖',
          desc: '北京本地万兆光缆覆盖',
          advantIcon: true
        },
        {
          image: require('../../assets/image/advantage/advantage3.png'),
          advant: '定制化',
          desc: '支持SDK提交<br/>无缝集成制作流程',
          advantIcon: true
        },
        {
          image: require('../../assets/image/advantage/advantage4.png'),
          advant: '数据安全',
          desc: '远超行业水准的存储硬件和安全策略',
          advantIcon: true
        },
        {
          image: require('../../assets/image/advantage/advantage5.png'),
          advant: '极速传输',
          desc: '文件秒速上传<br/>渲染结果自动下载',
          advantIcon: true
        },
        {
          image: require('../../assets/image/advantage/advantage6.png'),
          advant: '自动化提交',
          desc: '客户端智能分析/上传 实时查看渲染进度',
          advantIcon: true
        },
      ]
    }
  },
  created() {
    // console.log('clientWidth', document.documentElement.clientWidth)
  },
  methods: {
    advantageEnter (index, boolean) {
      if (document.documentElement.clientWidth > 992) {
        this.advantageList[index].advantIcon = boolean
      }
    },
    advantageLeave (index, boolean) {
      if (document.documentElement.clientWidth > 992) {
        this.advantageList[index].advantIcon = boolean
      }
    }
  },
}
</script>